import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarV2 from './navbar-v2';
import FooterV2 from './footer-v2';

export default function AccountDeletion() {
  // Sayfa yüklendiğinde en üste scroll yap
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      <NavbarV2 />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-orange-50 to-red-50 py-16 pt-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Hesap & Veri Silme</h1>
            <p className="text-lg text-gray-600 mb-6">
              Hesabınızı ve verilerinizi kalıcı olarak silme talimatları
            </p>
            <div className="flex items-center justify-center text-sm text-gray-500">
              <Link to="/" className="hover:text-red-500">Ana Sayfa</Link>
              <span className="mx-2">/</span>
              <span className="text-red-500">Hesap & Veri Silme</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white border rounded-xl p-8 shadow-sm">
              {/* Last Updated */}
              <div className="mb-8 p-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600">
                  <strong>Son güncelleme:</strong> 2 Eylül 2025
                </p>
              </div>

              {/* Warning Box */}
              <div className="mb-8 p-6 bg-red-50 border border-red-200 rounded-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">Önemli Uyarı</h3>
                    <p className="mt-1 text-sm text-red-700">
                      Bu işlem geri alınamaz. Hesabınız silindikten sonra verilerinize tekrar ulaşamazsınız.
                    </p>
                  </div>
                </div>
              </div>

              {/* Sections */}
              <div className="space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Genel Bilgi</h2>
                  <div className="text-gray-700">
                    <p>
                      Hesabınızı ve ilişkili kişisel verilerinizi dilediğiniz zaman silme talebinde bulunabilirsiniz. 
                      Bu işlem tamamen ücretsizdir ve herhangi bir gerekçe belirtmenize gerek yoktur.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Silme Talebi Nasıl Gönderilir?</h2>
                  <div className="text-gray-700">
                    <div className="bg-blue-50 p-6 rounded-lg mb-4">
                      <h3 className="font-semibold mb-3">Adım adım talimat:</h3>
                      <ol className="list-decimal ml-6 space-y-3">
                        <li>
                          <strong>Kayıtlı e-posta adresinizden</strong>{' '}
                          <a 
                            href="mailto:gudersamet@gmail.com?subject=Hesap%20Silme%20Talebi" 
                            className="text-red-500 hover:underline font-medium"
                          >
                            gudersamet@gmail.com
                          </a>
                          {' '}adresine e-posta gönderin
                        </li>
                        <li><strong>Konu satırı:</strong> "Hesap Silme Talebi"</li>
                        <li><strong>E-posta içeriğinde</strong> kullanıcı adınızı belirtin</li>
                        <li>Güvenlik nedeniyle <strong>sadece kayıtlı e-postadan</strong> gelen talepler kabul edilir</li>
                      </ol>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. İşlem Süresi</h2>
                  <div className="text-gray-700">
                    <p className="mb-4">
                      Talebiniz alındıktan sonra <strong>en geç 3 gün içinde</strong> hesabınız ve 
                      ilgili kişisel veriler silinir veya anonimleştirilir.
                    </p>
                    <p>
                      İşlem tamamlandığında size onay e-postası gönderilir.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Silinecek Veriler</h2>
                  <div className="text-gray-700">
                    <p className="mb-4">Aşağıdaki veriler kalıcı olarak silinecektir:</p>
                    <ul className="list-disc ml-6 space-y-2 mb-4">
                      <li>Profil bilgileri (kullanıcı adı, e-posta, profil fotoğrafı)</li>
                      <li>Hatim ve okuma istatistikleri</li>
                      <li>Grup katılım kayıtları</li>
                      <li>Uygulama içi mesajlar ve aktivite geçmişi</li>
                      <li>Tercih ve ayar bilgileri</li>
                    </ul>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Korunan/Anonimleştirilen Veriler</h2>
                  <div className="text-gray-700">
                    <p className="mb-4">
                      Yasal zorunluluk doğurmadığı sürece kalıcı veri saklanmaz. 
                      Ancak aşağıdaki veriler anonimleştirilmiş olarak tutulabilir:
                    </p>
                    <ul className="list-disc ml-6 space-y-2">
                      <li>Toplam kullanıcı sayıları (kimlik bilgisi olmadan)</li>
                      <li>Genel kullanım istatistikleri</li>
                      <li>Sistem log kayıtları (kişisel bilgi içermeden)</li>
                    </ul>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Devam Eden Gruplar</h2>
                  <div className="text-gray-700">
                    <p>
                      Hesabınız silindiğinde, katıldığınız gruplardaki ilerleme yüzdeleriniz 
                      toplu istatistiklerden çıkarılır. Bu durum diğer grup üyelerinin 
                      istatistiklerini etkilemez.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Sık Sorulan Sorular</h2>
                  <div className="text-gray-700">
                    <div className="space-y-4">
                      <div className="border-l-4 border-blue-500 pl-4">
                        <h4 className="font-medium">Hesabımı geri alabilir miyim?</h4>
                        <p className="text-sm text-gray-600">
                          Hayır, hesap silme işlemi geri alınamaz. Yeniden kayıt olmanız gerekir.
                        </p>
                      </div>
                      <div className="border-l-4 border-blue-500 pl-4">
                        <h4 className="font-medium">Verilerim gerçekten siliniyor mu?</h4>
                        <p className="text-sm text-gray-600">
                          Evet, kişisel verileriniz kalıcı olarak silinir veya anonimleştirilir.
                        </p>
                      </div>
                      <div className="border-l-4 border-blue-500 pl-4">
                        <h4 className="font-medium">Ücret ödeyecek miyim?</h4>
                        <p className="text-sm text-gray-600">
                          Hayır, hesap silme işlemi tamamen ücretsizdir.
                        </p>
                      </div>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. İletişim</h2>
                  <div className="text-gray-700">
                    <p className="mb-4">
                      Hesap silme işlemi ile ilgili sorularınız için:
                    </p>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="font-medium">E-posta:</p>
                      <a 
                        href="mailto:gudersamet@gmail.com" 
                        className="text-red-500 hover:underline"
                      >
                        gudersamet@gmail.com
                      </a>
                    </div>
                  </div>
                </section>
              </div>

              {/* Related Pages */}
              <div className="mt-12 pt-8 border-t border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">İlgili Sayfalar</h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <Link 
                    to="/privacy-policy" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Gizlilik Politikası</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Kişisel verilerinizin korunması hakkında
                    </p>
                  </Link>
                  <Link 
                    to="/terms-of-service" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Kullanım Koşulları</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Uygulama kullanım kuralları ve koşulları
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterV2 />
    </div>
  );
}
